(function () {
  'use strict';

  angular.module('unit.info').controller('FastDealCtrl', FastDealCtrl);

  FastDealCtrl.$inject = ['$scope', 'UnitInfo', '$stateParams'];

  function FastDealCtrl($scope, UnitInfo, $stateParams) {
    var unitId = $stateParams.id;

    $scope.setFastDeal = function () {
      UnitInfo.setFastDeal({ id: unitId }, {}).$promise.then(
        function () {
          $scope.unit.$promise.then(function (unit) {
            unit.status.type = 3;
          });

          angular
            .element(
              '.b-house__unit.b-houseroom[data-unit-id="' + unitId + '"]',
            )
            .addClass('-type_reservation');
        },
        function (error) {
          console.log('ERROR >>', error);
        },
      );
    };
  }
})();
